const axios = require('axios').default;
const Axios = require('axios');
const FileDownload = require('js-file-download');


const tzoffset = (new Date()).getTimezoneOffset()*60*1000;
var gLogoutTimeoutID = undefined;
var gContinuePopupTimerID = undefined;
var gContinueOverlayPopsupSecondsBeforeExpiry = 60;
var gContinueCallback = undefined;
var gShowNewVersionAvailableCallback = undefined;
var gCurrentPortalVersion = /*currentPortalVersion*/'20261014t155404'/*currentPortalVersion*/;


function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return(0);
}

function mustlog(endpoint) {
  return(endpoint.includes('localhostx'));
}

export function getServerRoot(norectify) {
  let root = window.location.origin;
  if (!norectify)
    if (window.location.origin.includes('3100')) 
      root = window.location.origin.replace('3100','3000');
  //console.log(`Origin is ${window.location.origin} and server root is set to ${root===window.location.origin?'same':root}`);
  return(root);
}

function clearTimeouts() {
  if (gLogoutTimeoutID) {
    clearTimeout(gLogoutTimeoutID);
    console.log('Cleared logout timer');
  }
  if (gContinuePopupTimerID) {
    clearTimeout(gContinuePopupTimerID);
    console.log('Cleared continue timer');
  }
}

function redirectToLogin() {
  localStorage.removeItem("Id");
  clearTimeouts();
  window.location='/coachportal/login';
}

async function askContinueSession() {
  // show modal overlay to ask continue session, and then, 
  // after user has clicked Continue or Logout,
  // call processUserContinueResponse with true if user wants to continue, false if not

  if (gContinueCallback) {
    console.log('Calling continue callback....');
    gContinueCallback();
  } else {
    console.log('Continue callback not defined.');
  }
  
  // this is just a simulation of that modal, with a one second delay before user clicks continue
  ///////////////////////////////////////////////////////////////////////////////////////////////
  //console.log('Do you want to continue?');
  //await new Promise(r => setTimeout(r, 1000));  
  //let userClickedContinue = true;
  ///////////////////////////////////////////////////////////////////////////////////////////////
  
  // when modal closes, call aserver.processUserContinueResponse(true|false)
  // here we call it without aserver. because we're in the very module that elsewhere gets imported with "import * as aserver from '../../APIClient';"
  //processUserContinueResponse(userClickedContinue);
}

export async function logout(component, returnToAdmin) {
  await get(`api/v2/logout`);
  clearTimeouts();
  for (let key in localStorage) {
    if (['Id','impersonator','coachEmailAddress','isBeingAssisted'].includes(key)) {
      localStorage.removeItem(key);
    }
  }
  component.setState({
    islogout: true
  });
  if (returnToAdmin) {
    window.location.href = `${getServerRoot()}/admin/coaches`;
  }
}

function resetExpiryTimers(millisecondsToExpiry) {
  if (!millisecondsToExpiry) {
    var expiry = parseInt(getCookie('sessionExpiryTimestamp'));
    millisecondsToExpiry = expiry - (new Date().getTime());
  }
  if (gLogoutTimeoutID) {
    clearTimeout(gLogoutTimeoutID);
  }
  if (gContinuePopupTimerID) {
    clearTimeout(gContinuePopupTimerID);
  }
  gLogoutTimeoutID = setTimeout(redirectToLogin, millisecondsToExpiry);
  gContinuePopupTimerID = setTimeout(askContinueSession, millisecondsToExpiry-gContinueOverlayPopsupSecondsBeforeExpiry*1000);
}

async function http(method, endpoint, data) {
  let querydelimiter = endpoint.includes('?')?'&':'?';
  try {
    let response = await axios[method](`${getServerRoot()}/${endpoint}${querydelimiter}t=${+ new Date()}`, data, {withCredentials: true});
    if (mustlog(endpoint)) {
        console.log(`================== ${method} ${endpoint} ====================`);
        console.log('SUCCESS');
        console.log(response);
        console.log('=====================================================================');
    }
    resetExpiryTimers();

    var availablePortalVersion = getCookie('availablePortalVersion');
    if (availablePortalVersion > gCurrentPortalVersion) {
      if (gShowNewVersionAvailableCallback)
        gShowNewVersionAvailableCallback();      
    }

    return(response);
  } catch (error) {
    if (error.response) {
      if (mustlog(endpoint)) {
        console.log(`================== ${method} ${endpoint} ====================`);
        console.log('ERROR');
        console.log(JSON.stringify(error.response));
        console.log('=====================================================================');
      }
      if (error.response.status===403) {
        redirectToLogin();
      }
      return(error.response);
    }
  };
}

export async function get(endpoint) {
    let response = await http('get', endpoint, {withCredentials: true});
    return(response);
};

export async function post(endpoint, data) {
    let response = await http('post', endpoint, data);
    return(response);
};

export async function put(endpoint, data) {
  let response = await http('put', endpoint, data);
  return(response);
};

export async function del(endpoint, data) {
  let response = await http('delete', endpoint, data);
  return(response);
};

export function serverroot() {
  return(getServerRoot());
}

export async function download(endpoint, filename, method, data) {
  try {
    let response = await Axios({
      url: `${getServerRoot()}/${endpoint}`,
      method: method??'GET',
      responseType: 'blob', 
      data: data??{}
    });
    resetExpiryTimers(30*60*1000); // thirty minutes expiry reset after each download, just like any other call to the portal.
    if (!filename) {
      try {
        filename = response.request.getResponseHeader('Content-Disposition').split('filename=')[1].split(';')[0];    
        filename = filename.replace(/"/g, '');
        filename = filename.replace(/'/g, '');
      } catch (error) {
        console.log(error);
        filename = 'report.pdf';
      }
    }
    FileDownload(response.data, filename);
    return(response);
  } catch (error) {
    if (error.response) {
      let t = await error.response.data.text();
      console.log('Text error response: ',t);
      let response = JSON.parse(t);
      if (error.response.status===403) {
        console.log('redirecting to log in');
        redirectToLogin();
      }
      return({data:response});
    }
  }
};

export function convertUTCToLocal(record, field, justDate) {
  let dt = record[field];
  let newValue = '-';
  if (dt) {
    dt = new Date(dt);
    newValue = (new Date(dt.getTime()-tzoffset)).toISOString().slice(0, 19).replace('T', ' ');
    if (justDate)
      newValue = newValue.slice(0,10);
  }
  record[field] = newValue;
};

// e.g. "EDT, UTC-4" - for a single, shared "times shown in your local time zone" note,
// rather than annotating every individual timestamp.
export function getLocalTimezoneLabel() {
  const now = new Date();
  const parts = new Intl.DateTimeFormat('en', { timeZoneName: 'short' }).formatToParts(now);
  const abbreviation = parts.find(p => p.type === 'timeZoneName')?.value || '';
  const offsetMinutes = -now.getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const hours = Math.floor(Math.abs(offsetMinutes) / 60);
  const minutes = Math.abs(offsetMinutes) % 60;
  const offset = `UTC${sign}${hours}${minutes ? ':' + String(minutes).padStart(2,'0') : ''}`;
  return abbreviation ? `${abbreviation}, ${offset}` : offset;
}

export function processUserContinueResponse(userWantsToContinue) {
  if (userWantsToContinue) {
    console.log('Ok, we will extend the session for you.');
    get(`api/v2/coaches/${localStorage.getItem("Id")}`);
  } else {
    console.log('Ok, we will log you out straight away.');
    redirectToLogin();
  }
}

export function location(url) {
  window.location.href = `${getServerRoot()}/${url}`;
}

export function goto(url) {
  window.location.assign(`${url}?${(Math.random()*10).toString().replace('.','')}`);
}

export function setContinueCallback(cb) {
  gContinueCallback = cb;
}

export function setNewVersionAvailableCallback(cb) {
  gShowNewVersionAvailableCallback = cb;
}

export function generateReportDownloadURL(reportType, coachGuid, assessmentGuid) {
  return(`publish/reports/coach/${reportType}/${coachGuid}/${assessmentGuid}`);
}     

export const Languages = [
  "english", 
  "french", 
  "german",
  "xhosa", 
  "hungarian",
  "slovak",
  "spanish", 
  "sesotho",
  "dutch",
  "portuguese",
  //"arabic",
  "ukrainian",
  "afrikaans",
  "tsonga",
  "italian",
  "chinese",
  "korean",
  "zulu" 
];

export const LanguageMap = {
  english: "English",
  french: "French",
  german: "German",
  xhosa: "Xhosa",
  hungarian: "Hungarian",
  slovak: "Slovak",
  spanish: "Spanish",
  sesotho: "Sesotho",
  dutch: "Dutch",
  portuguese: "Portuguese",
  //arabic: "Arabic",
  ukrainian: "Ukrainian",
  afrikaans: "Afrikaans",
  tsonga: "Tsonga",
  zulu: "Zulu",
  italian: "Italian",
  chinese: "Chinese",
  korean: "Korean"
};

export const AssessmentMap = {
  ennea: 'Enneagram',
  EIT: 'Maturity',
  full: 'Combined',
};

export const ReportLanguages = [ 'hungarian', 'slovak', 'afrikaans', 'italian', /*'xhosa'*/, 'spanish', /*'portuguese'*/];

